export const basicFont = {
    // fontFamily: "'Roboto', sans-serif",
    // fontSize: '16px',
    // lineHeight: '1.5',
    // color: '#333',
};

export const carInfoFont = {
    fontSize: 'small',
};

export const workshopBookingFont = {
    fontSize: 'small',
    fontWeight: 'bold',
};

export const greyFontColor = {
    color: 'rgb(71, 85, 105)'
};

// export const mainHeaderFontColor = {
//     color: 'rgb(30, 41, 59)'
// };

// export const secondaryHeaderFontColor = {
//     color: 'rgb(71, 85, 105)'
// };